import React, { useEffect, useState, createContext, useContext } from 'react';
import { translations, Language, Translations } from './translations';
interface LanguageContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: Translations;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLangState] = useState<Language>('es');
  useEffect(() => {
    const saved = localStorage.getItem('aneto-lang') as Language;
    if (saved && (saved === 'es' || saved === 'en')) {
      setLangState(saved);
    }
  }, []);
  const setLang = (newLang: Language) => {
    setLangState(newLang);
    localStorage.setItem('aneto-lang', newLang);
  };
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t: translations[lang]
  }} data-id="element-368" data-mp="2xuv5ya7u0k7s">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}